<template>
    <div class="audit_edit_pf pl10 mt20">
        <span class="dib">业务联系人信息</span><span class="line"></span>
        <div class="mt20">
            <el-form :model="basicForm" :rules="rules" ref="basicForm" label-width="207px" class="demo-ruleForm">
                <!-- 联系人姓名 -->
                <el-form-item class="mt20" label="联系人姓名:" prop="contactName">
                    <el-input class="w500" v-model="basicForm.contactName" placeholder="请输入联系人姓名" :maxlength="5"></el-input>
                </el-form-item>
                <!-- 联系人手机号 -->
                <el-form-item label="联系人手机号:" prop="contactMobile">
                    <el-input class="w500" v-model="basicForm.contactMobile" placeholder="请输入联系人手机号"></el-input>
                </el-form-item>
                <!-- 联系人座机 -->
                <el-form-item label="联系人座机:">
                    <el-input class="w500" v-model="basicForm.contactLandline" placeholder="请输入联系人座机"></el-input>
                </el-form-item>
                <!-- 联系人邮箱 -->
                <el-form-item label="联系人邮箱:" prop="contactEmail"
                              :rules="[
                                  { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                                  { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                                ]">
                    <el-input class="w500" v-model="basicForm.contactEmail" placeholder="请输入联系人邮箱"></el-input>
                </el-form-item>
                <!-- 联系人QQ -->
                <el-form-item label="联系人QQ:" prop="contactQQ">
                    <el-input class="w500" v-model="basicForm.contactQQ"
                              placeholder="请输入联系人QQ"></el-input>
                </el-form-item>
                <!-- 职务 -->
                <el-form-item label="职务:" prop="contactPosition">
                    <el-input class="w500" number v-model.number="basicForm.contactPosition"
                              placeholder="请输入联系人职务"></el-input>
                </el-form-item>

                <span class="dib">合同联系人信息</span><span class="line"></span>
                <!-- 联系人姓名 -->
                <el-form-item class="mt20" label="联系人姓名:" prop="contractContactName">
                    <el-input class="w500" v-model="basicForm.contractContactName" placeholder="请输入联系人姓名" :maxlength="5"></el-input>
                </el-form-item>
                <!-- 联系人手机号 -->
                <el-form-item label="联系人手机号:" prop="contractContactMobile">
                    <el-input class="w500" v-model="basicForm.contractContactMobile" placeholder="请输入联系人手机号"></el-input>
                </el-form-item>
                <!-- 联系人座机 -->
                <el-form-item label="联系人座机:">
                    <el-input class="w500" v-model="basicForm.contractContactLandline" placeholder="请输入联系人座机"></el-input>
                </el-form-item>
                <!-- 联系人邮箱 -->
                <el-form-item label="联系人邮箱:" prop="contractContactEmail"
                              :rules="[
                                  { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                                  { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                                ]">
                    <el-input class="w500" v-model="basicForm.contractContactEmail" placeholder="请输入联系人邮箱"></el-input>
                </el-form-item>
                <!-- 联系人QQ -->
                <el-form-item label="联系人QQ:" prop="contractContactQQ">
                    <el-input class="w500" v-model="basicForm.contractContactQQ"
                              placeholder="请输入联系人QQ"></el-input>
                </el-form-item>
                <!-- 职务 -->
                <el-form-item label="职务:" prop="contractContactPosition">
                    <el-input class="w500" number v-model.number="basicForm.contractContactPosition"
                              placeholder="请输入联系人职务"></el-input>
                </el-form-item>

                <span class="dib">客服联系人信息</span><span class="line"></span>
                <!-- 联系人姓名 -->
                <el-form-item class="mt20" label="联系人姓名:" prop="customServiceContactName">
                    <el-input class="w500" v-model="basicForm.customServiceContactName" placeholder="请输入联系人姓名" :maxlength="5"></el-input>
                </el-form-item>
                <!-- 联系人手机号 -->
                <el-form-item label="联系人手机号:" prop="customServiceContactMobile">
                    <el-input class="w500" v-model="basicForm.customServiceContactMobile" placeholder="请输入联系人手机号"></el-input>
                </el-form-item>
                <!-- 联系人座机 -->
                <el-form-item label="联系人座机:">
                    <el-input class="w500" v-model="basicForm.customServiceContactLandline" placeholder="请输入联系人座机"></el-input>
                </el-form-item>
                <!-- 联系人邮箱 -->
                <el-form-item label="联系人邮箱:" prop="customServiceContactEmail"
                              :rules="[
                                  { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                                  { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                                ]">
                    <el-input class="w500" v-model="basicForm.customServiceContactEmail" placeholder="请输入联系人邮箱"></el-input>
                </el-form-item>
                <!-- 联系人QQ -->
                <el-form-item label="联系人QQ:" prop="customServiceContactQQ">
                    <el-input class="w500" v-model="basicForm.customServiceContactQQ"
                              placeholder="请输入联系人QQ"></el-input>
                </el-form-item>
                <!-- 职务 -->
                <el-form-item label="职务:" prop="customServiceContactPosition">
                    <el-input class="w500" number v-model.number="basicForm.customServiceContactPosition"
                              placeholder="请输入联系人职务"></el-input>
                </el-form-item>


                <el-form-item class="mt50" label-width="207px">
                    <el-button type="primary" class="mr30" @click="returnPage">返回</el-button>
                    <el-button type="primary" class="mr30" @click="confirmSave('basicForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('手机号不能为空'));
                } else {
                    if (/^1[0-9]\d{9}$/.test(value) == false) {
                        callback(new Error('手机号格式不正确'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                suppliersId: 0,                               // 供应商id

                // 提交数据
                basicForm: {
                    contactName: '',						// 联系人姓名
                    contactMobile: '',					    // 联系人手机号
                    contactEmail: '',						// 联系人邮箱
                    contactQQ: '',							// 联系人QQ
                    contactPosition: '',				    // 联系人职务
                    contactLandline: '',                     // 联系人座机

                    contractContactName: '',						// 合同联系人姓名
                    contractContactMobile: '',					    // 合同联系人手机号
                    contractContactEmail: '',						// 合同联系人邮箱
                    contractContactQQ: '',							// 合同联系人QQ
                    contractContactPosition: '',				    // 合同联系人职务
                    contractContactLandline: '',                    //合同联系人座机

                    customServiceContactName: '',						// 联系人姓名
                    customServiceContactMobile: '',					    // 联系人手机号
                    customServiceContactEmail: '',						// 联系人邮箱
                    customServiceContactQQ: '',							// 联系人QQ
                    customServiceContactPosition: '',				    // 联系人职务
                    customServiceContactLandline: ''                     // 联系人座机
                },

                rules: {
                    contactName: [
                        {required: true, message: '请输入联系人姓名', trigger: 'blur'},
                        {max: 5, message: '最多5个字符', trigger: 'blur'}
                    ],
                    contactMobile: [
                        {required: true, validator: checkPhone, trigger: 'blur'}
                    ],
                    contactQQ: [
                        {required: true, message: '请输入联系人QQ', trigger: 'blur'}
                    ],

                    contractContactName: [
                        {required: true, message: '请输入联系人姓名', trigger: 'blur'},
                        {max: 5, message: '最多5个字符', trigger: 'blur'}
                    ],
                    contractContactMobile: [
                        {required: true, validator: checkPhone, trigger: 'blur'}
                    ],
                    contractContactQQ: [
                        {required: true, message: '请输入联系人QQ', trigger: 'blur'}
                    ],

                    customServiceContactName: [
                        {required: true, message: '请输入联系人姓名', trigger: 'blur'},
                        {max: 5, message: '最多5个字符', trigger: 'blur'}
                    ],
                    customServiceContactMobile: [
                        {required: true, validator: checkPhone, trigger: 'blur'}
                    ],
                    customServiceContactQQ: [
                        {required: true, message: '请输入联系人QQ', trigger: 'blur'}
                    ]
                }
            }
        },

        methods: {
            getTimeStr (val) {
                var date = new Date(val);
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = date.getDate() + ' ';
                return Y+M+D;
            },

            fetch () {
                var that = this;
                $.ajax({
                    url: '/suppliers/supplier/contact/find',
                    method: 'get',
                    success: function (result) {
                        if (!result.code) {
                            var data = result.data;
                            that.basicForm.contactName = data.contactName;
                            that.basicForm.contactMobile = data.contactMobile;
                            that.basicForm.contactEmail = data.contactEmail;
                            that.basicForm.contactQQ = data.contactQQ;
                            that.basicForm.contactPosition = data.contactPosition;
                            that.basicForm.contactLandline = data.contactLandline;

                            that.basicForm.contractContactName = data.contractContactName;
                            that.basicForm.contractContactMobile = data.contractContactMobile;
                            that.basicForm.contractContactEmail = data.contractContactEmail;
                            that.basicForm.contractContactQQ = data.contractContactQQ;
                            that.basicForm.contractContactPosition = data.contractContactPosition;
                            that.basicForm.contractContactLandline = data.contractContactLandline;

                            that.basicForm.customServiceContactName = data.customServiceContactName;
                            that.basicForm.customServiceContactMobile = data.customServiceContactMobile;
                            that.basicForm.customServiceContactEmail = data.customServiceContactEmail;
                            that.basicForm.customServiceContactQQ = data.customServiceContactQQ;
                            that.basicForm.customServiceContactPosition = data.customServiceContactPosition;
                            that.basicForm.customServiceContactLandline = data.customServiceContactLandline;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            confirmSave(formName) {
                var that = this;
                this.$refs[formName].validate((valid) => {
                    console.log('contact validation result is ' + valid);
                    if (valid) {
                        that.$prompt('请输入详细修改原因', '修改原因', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputValidator: function(val){return (val==null || val.trim().length<1) ? false:true},
                            inputErrorMessage: '请输入详细修改原因'
                        }).then(({ value }) => {
                            that.saveForm(value);
                        }).catch(() => {
                            that.$message({
                                type: 'info',
                                message: '已取消修改'
                            });
                        });
                    }
                })
            },

            saveForm (value) {
                var that = this;
                var data = {};
                data.suppliersId = 0;
                data.remark = value;
                data.contactName = that.basicForm.contactName;
                data.contactMobile = that.basicForm.contactMobile;
                data.contactEmail = that.basicForm.contactEmail;
                data.contactQQ = that.basicForm.contactQQ;
                data.contactPosition = that.basicForm.contactPosition;
                data.contactLandline = that.basicForm.contactLandline;

                data.contractContactName = that.basicForm.contractContactName;
                data.contractContactMobile = that.basicForm.contractContactMobile;
                data.contractContactEmail = that.basicForm.contractContactEmail;
                data.contractContactQQ = that.basicForm.contractContactQQ;
                data.contractContactPosition = that.basicForm.contractContactPosition;
                data.contractContactLandline = that.basicForm.contractContactLandline;

                data.customServiceContactName = that.basicForm.customServiceContactName;
                data.customServiceContactMobile = that.basicForm.customServiceContactMobile;
                data.customServiceContactEmail = that.basicForm.customServiceContactEmail;
                data.customServiceContactQQ = that.basicForm.customServiceContactQQ;
                data.customServiceContactPosition = that.basicForm.customServiceContactPosition;
                data.customServiceContactLandline = that.basicForm.customServiceContactLandline;

                $.ajax({
                    url: '/suppliers/supplier/contact/update',
                    data: JSON.stringify(data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'post',
                    success: function (result) {
                        if (!result.code) {
                            that.$message({
                                message: '保存成功!',
                                type: 'success'
                            });
                            setTimeout(function () {
                                that.$router.push({
                                    path:'/supplier_info?isStep=3'
                                })
                            }, 500)
                        } else {
                            that.$message({
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 返回
            returnPage(){
                this.$router.push({
                    path:'/supplier_info?isStep=3'
                })
            }

        },
        mounted () {
            this.$nextTick(function () {
                var that = this;
                var suppliersId = this.$route.query.suppliersId;
                this.suppliersId = suppliersId;
                var pageType = this.$route.query.pageType;
                if(1 == pageType){
                    this.$alert('检测到您的联系人信息尚未完善，请完善联系人信息！', '提示', {
                    confirmButtonText: 'OK',
                    callback: action => {that.fetch();}
                    });
                }else{
                    this.fetch();
                }
            })
        },
        computed: {

        },

        watch: {

        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .audit_edit_pf {
        padding-left: 60px;
        padding-right: 60px;
    }

    .line {
        margin-left: 3%;
        display: inline-block;
        width: 80%;
        height: 1px;
        border-bottom: 1px dashed #999;
        vertical-align: middle;
    }

    .second_line {
        margin-left: 3%;
        display: inline-block;
        width: 87%;
        height: 1px;
        border-bottom: 1px dashed #666;
        vertical-align: middle;
    }

    .word_num {
        display: inline-block;
        vertical-align: bottom;
        margin-bottom: 22px;
        margin-left: 5px;
        color: #666;
    }

    .pic_tip {
        font-size: 12px;
        color: #ff4949;
        line-height: 1px;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
    }
    .edit_wrap {
        width: 1050px;
        margin: 50px auto;
        border: 1px solid #eee;
        .edit_tab {
            display: inline-block;
            width: 262px;
            height: 46px;
            text-align: center;
            line-height: 46px;
            color: #fff;
            background: #ff6c83;
        }
        .active_tab {
            background: #ff4a7d;
        }
        .tip_word {
            margin-top: 20px;
            width: 1048px;
            height: 160px;
            background: #f9f9f9;
            padding: 10px;
        }
    }
    .fixeds {
        position: absolute;
        top: 37px;
        right: 69px;
        background: #fff;
        z-index: 2;
        width: 148px;
        height: 148px;
    }
    .pic_min_skan {
        width: 60px;
        height: 60px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .rule_star {
        position: relative;
        left:-76px;
    }
    .rule_star2 {
        position: relative;
        left:-120px;
    }
    .rule_star3 {
        position: relative;
        left:-190px;
    }
    .rule_star4 {
        position: relative;
        left:-132px;
    }
    .rule_star5 {
        position: relative;
        left:-160px;
    }
    .rule_star6 {
        position: relative;
        left:-150px;
    }
    .rule_star200 {
        position: relative;
        left:-200px;
    }
    .rule_star105 {
        position: relative;
        left:-105px;
    }
    .ml_10 {
        margin-left: -10px;
    }
    .lh20 {
        line-height: 20px;
    }
</style>


// WEBPACK FOOTER //
// contactInfo.vue?1f3315a2